<!-- 网站首页 -->
<template>
  <div class="group p_flex p_column p_align_items">
    <template v-if="type==='pc'">
      <el-image style="width: 180px; height: 180px;border-radius: 50%;" :src="GET_USER.avatar"></el-image>
      <input type="file" accept="image/*" style="display:none;" :multiple="false" ref="iptRef" @change="onFileChange">
      <div @click="chooseImg" class="change_btn p_hand bg_ffffff border_radius6 font_15 color_DC000C p_text_center">
        {{ $t('login.change') }}
      </div>
    </template>
    <template v-if="type==='h5'">
      <el-image style="width: 90px; height: 90px;border-radius: 50%;" :src="GET_USER.avatar"></el-image>
      <input type="file" accept="image/*" style="display:none;" :multiple="false" ref="iptRef" @change="onFileChange">
      <div @click="chooseImg"
        class="change_btn_h5 p_hand bg_ffffff border_radius6 font_15 color_DC000C p_text_center">
        {{ $t('login.change') }}
      </div>
    </template>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    public_uploadimg,
    login_edituser
  } from '@/network/index.js'; //这里为文件上传的接口换成自己的文件
  export default {

    data() {
      return {}
    },
    props: {
      type: {
        type: String,
        default: 'pc'
      }
    },
    computed: {
      ...mapGetters('login', ['GET_USER'])
    },
    methods: {
      chooseImg() { // 选择图片-点击事件
        // 目的：为了让input[type=file]标签，让他再用JS代码来触发它的点击事件（导致它默认行为给一个文件选择窗口）
        // 原因：input[type=file]它是原生标签，样式不太好改
        // 解决：移花接木
        this.$refs.iptRef.click() // 模拟 input[type=file] 的点击行为
      },
      onFileChange(e) { // 选择图片确定了
        const files = e.target.files // 拿到用户选择的文件数组
        //console.log('用户选择的文件数组：', files[0])
        if (files.length === 0) { // 说明文件选择的窗口打开了，但是它一个文件都没选择就点击了确定关闭了选择弹框

        } else { // 证明选择了文件（默认只能选择一个文件，如果选择多个，需要给input标签加额外原生属性）
          //console.log('用户选择的文件数组：', files[0])
          // 目标：选择图片文件，要给到img标签上做纯前端的预览
          // 知识点：img标签的src值
          //  只能是图片的链接地址（外链http://开头，或者图片的相对路径）
          //  或者是图片的base64字符串（而且字符串必须是data：image/png；base64，图片转base64字符串）

          // 解决方案1：文件 -》 内存临时地址（这个地址只能在js里内存里不能发给后台）
          // 语法：URL.createObjectURL(文件)
          // 返回值：内存临时地址
          // this.avatar = URL.createObjectURL(files[0])

          // 解决方案2：将文件转成base64（此字符串可以传给后台）
          // 语法：
          const fr = new FileReader()
          fr.readAsDataURL(files[0]) // 传入文件对象开始阅读
          fr.onload = (e) => { // onload等待把文件读成base64字符串后会触发onload事件函数
            // e.target.result的值就是读完的结果
            //console.log(e.target.result)
            // 赋予给变量，让他显示在img的src里
            this.createCanvasToImg(e.target.result, (res) => {
              //console.log(res)
              this.base64ImgtoFile(res)
              this.uploadFile(this.base64ImgtoFile(res))
              //console.log()
              // this.img_src = res
            })
          }
        }
      },
      //======================================
      createCanvasToImg(url, callback) { //剪切图片
        let canvas, context;
        // canvas 转 image
        let canvasToImg;
        // 创建canvas
        canvas = document.createElement("canvas");
        context = canvas.getContext("2d");
        // 加载资源
        let luckyCardImg = new Image();
        luckyCardImg.setAttribute("crossOrigin", "anonymous"); // 解决跨域 Canvas 污染问题
        luckyCardImg.src = url;
        luckyCardImg.onload = () => {
          if (luckyCardImg.width === luckyCardImg.height) { //原本就是正方形时
            canvas.width = luckyCardImg.width;
            canvas.height = luckyCardImg.height;
            context.drawImage(luckyCardImg, 0, 0, luckyCardImg.height, luckyCardImg.height)
          }
          if (luckyCardImg.width > luckyCardImg.height) { //宽度比高度长
            canvas.width = luckyCardImg.height;
            canvas.height = luckyCardImg.height;
            context.drawImage(luckyCardImg, (luckyCardImg.width - luckyCardImg.height) / 2, 0, luckyCardImg.height,
              luckyCardImg.height, 0, 0, luckyCardImg.height,
              luckyCardImg.height)
          }
          if (luckyCardImg.width < luckyCardImg.height) { //高度比宽度长时
            canvas.width = luckyCardImg.width;
            canvas.height = luckyCardImg.width;
            context.drawImage(luckyCardImg, 0, (luckyCardImg.height - luckyCardImg.width) / 2, luckyCardImg.width,
              luckyCardImg.width, 0, 0, luckyCardImg.width, luckyCardImg.width)
          }
          canvasToImg = canvas.toDataURL("image/png");
          callback(canvasToImg)
        }
      },
      base64ImgtoFile(dataurl, filename = 'file') {
        //将base64格式分割：['data:image/png;base64','XXXX']
        const arr = dataurl.split(',');
        // .*？ 表示匹配任意字符到下一个符合条件的字符 刚好匹配到：
        // image/png
        const mime = arr[0].match(/:(.*?);/)[1]; //image/png
        //[image,png] 获取图片类型后缀
        const suffix = mime.split('/')[1]; //png
        const bstr = atob(arr[1]); //atob() 方法用于解码使用 base-64 编码的字符串
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime
        });
      },
      uploadFile(file) {
        const formData = new FormData();
        formData.append("uploadImg", file)
        public_uploadimg(formData).then((res) => {
          if (res.code === '0') {
            login_edituser({
              userid: this.GET_USER.userId,
              nickName: this.GET_USER.nickName,
              avatarUrl: res.data
            }).then(res2 => {
              if (res2.code === '0') {
                this.$message({
                  message: 'success!',
                  type: 'success'
                });
                // 刷新用户数据
                this.$emit("callback")
                this.$store.dispatch('login/USER_REFRESH');
              }
            });
          }
        })
      },










    }
  }
</script>

<style scoped="scoped">
  .change_btn {
    width: 140px;
    height: 42px;
    line-height: 40px;
    border: 1px solid #dc000c;
    margin: 30px 0 90px 0;
  }
  .change_btn_h5 {
    width: 120px;
    height: 42px;
    line-height: 40px;
    border: 1px solid #dc000c;
    margin: 30px 0 60px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-uploadavatar/public-uploadavatar.vue